import { SonntagButtonV2 as Button } from '@getgrover/ui';
import styled, { SimpleInterpolation, css } from 'styled-components';

export const Container = styled.div`
    flex: 1 0 auto;
    padding-bottom: 64px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 5%;
    width: 100%;
    color: ${({ theme }): string => theme.colors.secondary};

    ${({ theme }): SimpleInterpolation => theme.superQuery.all.and.maxWidth.tabletMax.css`
    padding-bottom: 42px;
    `};
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    width: 459px;
    overflow-wrap: anywhere;
    ${({ theme }): SimpleInterpolation => theme.superQuery.all.and.maxWidth.tabletMax.css`
        padding: ${theme.spacers.XL} ${theme.spacers.M};
        flex: 1 0 auto;
        width: inherit;
    `};

    ${({ theme }): SimpleInterpolation => theme.superQuery.all.and.minWidth.tabletMax.css`
        padding-top: 72px;
        padding-bottom: 88px;
    `};
`;

export const Name = styled.h2`
    ${({ theme }): SimpleInterpolation => theme.typography.Subheadline}
    margin-bottom: ${({ theme }): string => theme.spacers.L};
`;

export const Text = styled.p`
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    margin-bottom: ${({ theme }) => theme.spacers.L};
`;

export const AccountButton = styled(Button)`
    font-weight: 500;
    padding: ${({ theme }) => theme.spacers.S};
    height: 32px;
    justify-content: start;

    div {
        padding: ${({ theme }) => theme.spacers.S};
    }

    svg {
        margin: 0;
    }
`;

export const RequestChangeButton = styled(Button)`
    padding: 6px 16px;
    gap: 10px;
    height: 32px;
`;

export const CompanyInfo = styled.div`
    margin-top: 57px;
    margin-bottom: 64px;
    gap: 16px;
`;

export const CompanyInfoSection = styled.div``;

export const CapitalLettersTitle = styled.p`
    ${({ theme }) => theme.typography.SmallCapsHeadline};
    color: ${({ theme }) => theme.colors['Level 5']};
`;

export const Divider = styled.div`
    max-width: 459px;
    width: 90%;
    height: 3px;
    border-radius: 10px;
    background: ${({ theme }) =>
        theme.name !== 'dark' ? theme.colors['Level 1'] : theme.colors.ElementBackground};
    margin-bottom: ${({ theme }) => theme.spacers['4XL']};
    margin-top: ${({ theme }) => theme.spacers.XL};
`;

export const BoxWrap = styled.div`
    height: min-content;
    box-sizing: border-box;
    padding: ${({ theme }) => `${theme.spacers.XL} 0`};
    display: flex;
    align-items: start;

    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        margin-bottom: ${theme.spacers.M};
        &:first-child {
            margin-right: 0;
        }
    `};
`;

export const IconWrapper = styled.div`
    height: 48px;
    width: 48px;
    background-color: ${({ theme }) => theme.colors.secondaryBackground};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        fill: ${({ theme }) => theme.colors.secondary};
    }
`;

export const Title = styled.h2`
    ${({ theme }) => css(theme.typography.SuperTinyHeadline)};
    padding-top: ${({ theme }) => css(theme.spacers.L)};
`;

export const InfoBoxText = styled.p`
    ${({ theme }) => css(theme.typography.Paragraph)};
    padding-bottom: ${({ theme }) => css(theme.spacers.L)};
    padding-top: ${({ theme }) => css(theme.spacers.S)};
`;

export const AddressText = styled.p`
    padding-top: 4px;
    font-size: 16px;
    font-family: Inter;
    font-weight: 500;
    line-height: 150%;
`;

export const IconBadgeWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const TextWrapper = styled.div`
    margin-left: ${({ theme }) => theme.spacers.L};
`;

export const Description = styled.p`
    color: ${({ theme }) => theme.colors['Level 5']};
    font-weight: 500;
    line-height: 150%;
    margin-top: ${({ theme }) => theme.spacers.L};
`;
